import Vue from 'vue';
import Vuex from 'vuex';
import Styles from './data/Styles';
import HELPERS from './data/helpers';
// import WAIVERS from '@/store/data/Waivers';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // waivers: WAIVERS,
    schedule: HELPERS.groups,
    days: HELPERS.days,
    regInfo: HELPERS.regInfo,
    styles: Styles,
    aboutSlides: [
      {
        header: 'Owners',
        contents: [
          {
            primary: 'owners'
          }
        ]
      },
      {
        header: 'Teachers',
        contents: [
          {
            primary: 'bw-contemporary'
          },
          {
            primary: 'jazz'
          },
          {
            primary: 'bw-tumbling'
          },
          {
            primary: 'ballet'
          },
          {
            primary: 'bw-jazzfunk'
          }
        ]
      }
    ],
    contactSlides: [
      {
        header: 'Owners',
        contents: [
          {
            primary: 'owners'
          }
        ]
      },
      {
        header: 'Teachers',
        contents: [
          {
            primary: 'jazzfunk'
          },
          {
            primary: 'bw-jazz'
          },
          {
            primary: 'contemporary'
          },
          {
            primary: 'bw-ballet'
          }
        ]
      }
    ]
  },
  getters: {
    days: ({ days }) => Object.entries(days).map(([k, v]) => ({ k, v }))
  },

  mutations: {},

  actions: {},

  modules: {}
});
